module.exports = __webpack_public_path__ + "img/47.82b32e44.jpg";